import { BonusAttendanceList } from "./BonusStatementList";
export default {
    list: BonusAttendanceList
};
